import { Info } from "lucide-react";
import { Link } from "@tanstack/react-router";
import { site } from "@/lib/site";

// Runs across every public page. In addition to the standard scope-of-work
// disclaimer, this bar surfaces the CIPC company registration number at
// the very top of the site so any visitor or counterparty can verify us
// without hunting for it in the footer.
export function ComplianceBar() {
  return (
    <div className="bg-navy text-navy-foreground">
      <div className="container-narrow flex flex-col items-center gap-1 px-4 py-1.5 text-center text-[11px] leading-snug sm:text-xs md:flex-row md:justify-between md:gap-3 md:py-2">
        <p className="flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 text-navy-foreground/90">
          <Info className="h-3.5 w-3.5 text-gold" />
          <span>
            Legal support &amp; compliance services —{" "}
            <strong className="text-gold">not an admitted attorney</strong>; we
            do provide legal advice on non-reserved matters, but no reserved
            work or court representation.
          </span>

          <Link
            to="/disclaimer"
            className="underline decoration-gold/60 underline-offset-2 hover:text-gold"
          >
            Read our full disclaimer
          </Link>
        </p>
        <p className="whitespace-nowrap text-[10.5px] tracking-wide text-navy-foreground/85 sm:text-[11px]">
          <span className="text-gold">CIPC Reg&nbsp;</span>
          <span className="font-mono">{site.registration.number}</span>
          {site.registration.taxNumber ? (
            <>
              <span className="mx-1.5 text-navy-foreground/40">·</span>
              <span className="text-gold">Tax&nbsp;</span>
              <span className="font-mono">{site.registration.taxNumber}</span>
            </>
          ) : null}
        </p>
      </div>
    </div>
  );
}
